import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

type ConnectionStatus = 'connected' | 'connecting' | 'disconnected';

interface ShellQrLinkPanelProps {
    readonly visible: boolean;
    readonly connectionStatus: ConnectionStatus;
    readonly sessionId: string;
    readonly mobileUrl: string;
    readonly logs: ReadonlyArray<string>;
}

function ShellQrLinkPanel(props: ShellQrLinkPanelProps): React.ReactElement | null {
    if (!props.visible) {
        return null;
    }

    const statusLabel = props.connectionStatus === 'connected' ? 'Status: Connected' : 'Status: Not Connected';

    return (
        <div className="shell-tv-qr-panel" role="region" aria-label="Mobile controller linking panel">
            <div className="shell-tv-qr-background" />
            <div className="shell-tv-qr-content">
                <div className="shell-tv-qr-code-container" id="mobileQrContainer">
                    <div className="shell-tv-qr-code" id="mobileQrCode">
                        <QRCodeCanvas
                            value={props.mobileUrl}
                            size={301}
                            level="H"
                            marginSize={0}
                            title="Mobile controller QR code"
                        />
                    </div>
                </div>
                <div className={`shell-tv-status shell-tv-status-${props.connectionStatus}`} id="mobileConnectionStatus">
                    {statusLabel}
                </div>
                <div className="shell-tv-debug" aria-hidden="true">
                    <div>Session: {props.sessionId}</div>
                    {props.logs.length > 0 ? <div>{props.logs[props.logs.length - 1]}</div> : null}
                </div>
            </div>
        </div>
    );
}

export default ShellQrLinkPanel;
